import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { OnboardingContentWrapper } from "components/Docs/OnboardingContentWrapper";
import { EmbeddingEvent } from "onboarding/llm-analytics/_snippets/embedding-event.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <OnboardingContentWrapper mdxType="OnboardingContentWrapper">
    <EmbeddingEvent mdxType="EmbeddingEvent" />
    </OnboardingContentWrapper>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      